import { notificationService } from '../_services';

const getDefaultState = () => {
  return {
    all: {},
    current: {}
  }
}

export const notifications = {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    resetState ({ commit }) {
      commit('resetState')
    },
    collectionAccessRequest({ commit }, payload){
      commit('collectionAccessRequest');
      notificationService.collectionAccessRequest(payload)
      .then(
        notifications => commit('collectionAccessRequestSuccess', response),
        error => commit('collectionAccessRequestFailure', error)
      )
    },
    collectionAccessInvite({ commit }, payload){
      commit('collectionAccessInvite');
      notificationService.collectionAccessInvite(payload)
      .then(
        notifications => commit('collectionAccessInviteSuccess', response),
        error => commit('collectionAccessInviteFailure', error)
      )
    },
    recipeAccessRequest({ commit }, payload){
      commit('recipeAccessRequest');
      notificationService.recipeAccessRequest(payload)
      .then(
        notifications => commit('recipeAccessRequestSuccess', response),
        error => commit('recipeAccessRequestFailure', error)
      )
    },
    recipeAccessInvite({ commit }, payload){
      commit('recipeAccessInvite');
      notificationService.recipeAccessInvite(payload)
      .then(
        notifications => commit('recipeAccessInviteSuccess', response),
        error => commit('recipeAccessInviteFailure', error)
      )
    },
    recipePublishRequest({ commit }, payload){
      commit('recipePublishRequest');
      notificationService.recipePublishRequest(payload)
      .then(
        notifications => commit('recipePublishReqestSuccess', notifications),
        error => commit('recipePublishRequestFailure', error)
      )
    },
    recipeShare({ commit }, payload){
      commit('recipeShare');
      notificationService.recipeShare(payload)
      .then(
        notifications => commit('recipeShareSuccess', notifications),
        error => commit('recipeShareFailure', error)
      )
    },
    respondToNotification({ commit }, payload){
      commit('respondToNotification');
      notificationService.respondToNotification(payload)
      .then(
          commit('respondToNotificationSuccess'),
          error => commit('respondToNotificationFailure', error)
      )
      return true;
    },
    getAllNotifications({ commit }) {
      commit('getAllNotificationsRequest');
      notificationService.getAll()
      .then(
          notifications => commit('getAllNotificationsSuccess', notifications),
          error => commit('getAllNotificationsFailure', error)
      );
    },
    deleteNotification({ commit }, payload){
      commit('deleteNotificationRequest');
      notificationService.deleteNotification(payload)
      .then(
        commit('deleteNotificationSuccess'),
        error => commit('deleteNotificationFailure', error)
      )
      return true;
    }
  },
  mutations: {
    resetState (state) {
      Object.assign(state, getDefaultState())
    },
    getAllNotificationsRequest(state) {
      state.loading = 'Loading'
    },
    getAllNotificationsSuccess(state, notifications) {
        state.all = Object.values(notifications);
        state.loading = false;
    },
    getAllNotificationsFailure(state, error) {
        state.all = { error };
        state.loading = false;
    },
    getAllIngredientsRequest(state) {
      state.loading = 'Loading'
    },
    getAllIngredientsSuccess(state, ingredients) {
        state.all = Object.values(ingredients);
        state.loading = false;
    },
    getAllIngredientsFailure(state, error) {
        state.all = { error };
        state.loading = false;
    },
    recipeAccessRequest(state, response) {
    },
    recipeAccessRequestSuccess(state, response) {
    },
    recipeAccessRequestFailure(state, error) {
    },
    recipeAccessInvite(state, response) {
    },
    recipeAccessInviteSuccess(state, response) {
      //if(tag.id == state.current.tag.id){
      //  state.current = tag;
      //}
    },
    recipeAccessInviteFailure(state, error) {
      //state.update = { error };
    },
    recipePublishRequest(state, response) {
      //state.current = tag
    },
    recipePublishRequestSuccess(state, response) {
      //if(tag.id == state.current.tag.id){
      //  state.current = tag;
      //}
    },
    recipePublishRequestFailure(state, error) {
      //state.update = { error };
    },
    recipeShare(state, response) {
      //state.current = tag
    },
    recipeShareSuccess(state, response) {
      //if(tag.id == state.current.tag.id){
      //  state.current = tag;
      //}
    },
    recipeShareFailure(state, error) {
      //state.update = { error };
    },
    collectionAccessRequest(state, response) {
      //state.current = tag
    },
    collectionAccessRequestSuccess(state, response) {
      //if(tag.id == state.current.tag.id){
      //  state.current = tag;
      //}
    },
    collectionAccessRequestFailure(state, error) {
      //state.update = { error };
    },
    collectionAccessInvite(state, response) {
      //state.current = tag
    },
    collectionAccessInviteSuccess(state, response) {
    },
    collectionAccessInviteFailure(state, error) {
    },
    deleteNotificationRequest(state, tag) {
      state.current = tag
    },
    deleteNotificationSuccess(state) {
        state.current = {};
        return true;
    },
    deleteNotificationFailure(state, error) {
      state.update = { error };
    } 
  }
}